import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const AuthCallback = () => {
  const navigate = useNavigate();
  const { loginWithToken } = useAuth();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const processCallback = async () => {
      const hash = window.location.hash;
      const sessionId = new URLSearchParams(hash.substring(1)).get('session_id');

      if (!sessionId) {
        navigate('/auth', { replace: true });
        return;
      }

      try {
        const response = await axios.post(`${API}/auth/google/session`, { session_id: sessionId });
        const { token, user } = response.data;
        loginWithToken(token, user);
        // Clear hash and redirect
        window.history.replaceState(null, '', window.location.pathname);
        navigate('/', { replace: true });
      } catch (error) {
        console.error('Google auth error:', error);
        navigate('/auth', { replace: true });
      }
    };

    processCallback();
  }, [navigate, loginWithToken]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#FDFBF7]">
      <div className="text-center">
        <Loader2 className="animate-spin text-[#38B2AC] mx-auto mb-4" size={32} />
        <p className="text-gray-500">Iniciando sesión...</p>
      </div>
    </div>
  );
};

export default AuthCallback;
